<div class="ui-g">
  <div class="ui-g-3 ui-md-12 ui-sm-12">
    <div class="" style="height: 100%; padding-bottom: 10px">
      <h4 *ngIf="org_type == 'customer' && orgnodes.length < 1">
        You currently dont have departments added. Click below to add one,
      </h4>
      <h4 *ngIf="org_type == 'supplier' && orgnodes.length < 1">
        You currently dont have regions added. Click below to add one,
      </h4>

      <div class="ui-g btn-to-right">
        <button
          type="button"
          class="toggleButton"
          pButton
          (click)="collapseAll()"
          label="Collapse All"
        ></button>
        <button
          type="button"
          class="toggleButton"
          pButton
          (click)="expandAll()"
          label="Expand All"
        ></button>
      </div>

      <p-tree
        *ngIf="selectedNode != undefined && orgnodes.length > 0"
        [value]="orgnodes"
        selectionMode="single"
        [(selection)]="selectedNode"
        (onNodeSelect)="nodeSelect($event)"
        autoWidth="false"
        [style]="{ width: '100%' }"
      ></p-tree>

      <!--organisation structure  buttons-->
      <div class="ui-g btn-to-right" style="padding-top: 10px; padding-bottom: 10px">
        <div *ngIf="org_type == 'supplier'">
          <button type="button" pButton (click)="addregion()" label="Add Region"></button>
        </div>

        <div *ngIf="org_type == 'customer'">
          <button type="button" pButton (click)="adddpt()" label="Add Department"></button>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-g-9 ui-md-12 ui-sm-12" *ngIf="orgnodes.length > 0">
    <div
      class="card card-w-title"
      style="margin-bottom: 0px"
      *ngIf="currentnodetype == 'Region' || currentnodetype == 'Depot'"
    >
      <form
        [formGroup]="currRegionForm"
        (ngSubmit)="saveRegion(currRegionForm.value)"
        autocomplete="off"
      >
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div class="ui-g">
            <h2 class="sub-header-bar">Region</h2>
            <div class="ui-g-12">
              <div class="ui-grid-row">
                <div class="ui-grid-col-2"><label for="rName">Name</label></div>
                <div class="ui-grid-col-10">
                  <input pInputText id="rName" formControlName="name" maxlength="100" />
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g btn-to-right">
            <div>
              <button
                type="submit"
                pButton
                [disabled]="currRegionForm.invalid"
                label="Save"
              ></button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div
      class="card card-w-title"
      style="margin-bottom: 0px"
      *ngIf="currentnodetype == 'Department' || currentnodetype == 'Team'"
    >
      <form
        [formGroup]="currDepartmentForm"
        (ngSubmit)="saveDepartment(currDepartmentForm.value)"
        autocomplete="off"
      >
        <div class="ui-grid ui-grid-responsive ui-fluid">
          <div class="ui-g">
            <h2 class="sub-header-bar">Department</h2>
            <div class="ui-g-12">
              <div class="ui-grid-row">
                <div class="ui-grid-col-2"><label for="dpName">Name</label></div>
                <div class="ui-grid-col-10">
                  <input pInputText id="dpName" formControlName="name" maxlength="100" />
                </div>
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-row">
                <div class="ui-grid-col-2"><label for="tAccountCode">Cost Code</label></div>
                <p-dropdown
                  class="ui-grid-col-10"
                  id="tAccountCode"
                  [options]="costCodes"
                  formControlName="accountCodeId"
                  autoWidth="false"
                  [style]="{ width: '100%' }"
                ></p-dropdown>
              </div>
            </div>
            <div class="ui-g-12">
              <div class="ui-grid-row">
                <div class="ui-grid-col-2">
                  <label for="tAccountCode"
                    >Invoicing
                    <i
                      class="pi pi-info-circle"
                      style="vertical-align: text-bottom"
                      pTooltip="{{ dptLevelInvoiceInfo }}"
                    ></i
                  ></label>
                </div>
                <div class="ui-grid-col-10">
                  <p-checkbox
                    label="Department level invoicing"
                    id="deptInvoicing"
                    class="ui-grid-col-4"
                    formControlName="deptLevelInvoicingEnabled"
                    (onChange)="deptLevelInvoicingChanged($event)"
                    binary="true"
                  ></p-checkbox>
                  <p-dropdown
                    id="invoiceAddress"
                    [options]="customerInvoiceAddressesSelect"
                    class="ui-grid-col-4"
                    [disabled]="!deptLevelInvoicingEnabled"
                    formControlName="invoiceAddressId"
                    autoWidth="false"
                    [style]="{ width: '400px' }"
                    (onChange)="deptLevelInvoicingAddressChanged($event)"
                  ></p-dropdown>
                </div>
              </div>
            </div>

            <div class="ui-g-12">
              <div class="ui-grid-row">
                <div class="ui-grid-col-2">Notifications</div>
                <div class="ui-grid-col-10">
                  <p-checkbox
                    label="Pickup Notification"
                    class="ui-grid-col-4"
                    id="dpNotification"
                    formControlName="pickupNotification"
                    binary="true"
                  ></p-checkbox>

                  <p-checkbox
                    label="Dropoff Notification"
                    class="ui-grid-col-4"
                    id="ddNotification"
                    formControlName="dropoffNotification"
                    binary="true"
                  ></p-checkbox>
                </div>
              </div>
            </div>

            <div class="ui-g-12" *ngIf="isUserImpersonating">
              <div class="ui-grid-row">
                <div class="ui-grid-col-2">Carryover</div>
                <div class="ui-grid-col-10">
                  <p-checkbox
                    label="Restrict Carryover"
                    class="ui-grid-col-4"
                    id="chkRestrictCarryover"
                    formControlName="restrictCarryover"
                    binary="true"
                  ></p-checkbox>

                  <p-checkbox
                    label="Restrict Weekend Carryover"
                    class="ui-grid-col-4"
                    id="chkRestrictWeekendCarryover"
                    formControlName="restrictWeekendCarryover"
                    binary="true"
                  ></p-checkbox>
                  <div class="flex align-items-center">
                    <span>Carryover Additional Mileage Threshold</span>
                    <input
                      pInputText
                      id="carryoverAdditionalMileageThreshold"
                      formControlName="carryoverAdditionalMileageThreshold"
                      maxlength="100"
                      placeholder="Carryover Additional Mileage Threshold"
                    />
                    <span>%</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="ui-g-12" *ngIf="isUserImpersonating">
              <div class="ui-grid-row">
                <div class="ui-grid-col-2">Job Hold Config</div>
                <div class="ui-grid-col-10">
                  <p-checkbox
                    label="Override Global Hold Config?"
                    class="ui-grid-col-4"
                    id="chkOverrideJobHoldTimings"
                    formControlName="overrideJobHoldTimings"
                    binary="true"
                  ></p-checkbox>
                  <input
                    pInputText
                    id="minimumBuyItNowHours"
                    formControlName="minimumBuyItNowHours"
                    maxlength="100"
                    placeholder="Minimum BIN Hours"
                    style="width: 400px"
                  />
                </div>
              </div>
            </div>

            <div class="ui-g-12">
              <div class="ui-grid-row">
                <div class="ui-grid-col-2">Job Tagging</div>
                <div class="ui-grid-col-10">
                  <p-checkbox
                    label="Enforce Job Tagging?"
                    class="ui-grid-col-4"
                    id="chkIsJobTaggingEnforced"
                    formControlName="isJobTaggingEnforced"
                    binary="true"
                  ></p-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="ui-g btn-to-right">
            <div>
              <span class="md-inputfield">
                <button
                  type="submit"
                  class="btn-to-right"
                  pButton
                  [disabled]="currDepartmentForm.invalid"
                  label="Save"
                ></button>
              </span>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div style="padding-top: 10px" *ngIf="currentnodetype == 'Team'">
      <div class="card card-w-title" style="margin-bottom: 0px">
        <form
          [formGroup]="currTeamForm"
          (ngSubmit)="saveTeam(currTeamForm.value)"
          autocomplete="off"
        >
          <div class="ui-grid ui-grid-responsive ui-fluid">
            <div class="ui-g">
              <h2 class="sub-header-bar">Team</h2>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="tName">Name</label></div>
                  <div class="ui-grid-col-10">
                    <input pInputText id="tName" formControlName="name" maxlength="100" />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="tAccountCode">Cost Code</label></div>
                  <p-dropdown
                    class="ui-grid-col-10"
                    id="tAccountCode"
                    [options]="costCodes"
                    formControlName="accountCodeId"
                    autoWidth="false"
                    [style]="{ width: '100%' }"
                  ></p-dropdown>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2">
                    <label for="current_teamPrimaryContactEmail">Primary Contact Email</label>
                  </div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      id="current_teamPrimaryContactEmail"
                      formControlName="primaryContactEmail"
                      maxlength="254"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2">
                    <label for="current_teamSecondaryContactEmail">Secondary Contact Email</label>
                  </div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      id="current_teamSecondaryContactEmail"
                      formControlName="secondaryContactEmail"
                      maxlength="254"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12" *ngIf="isUserImpersonating">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2">KPIs</div>
                  <div class="ui-grid-col-10">
                    <p-checkbox
                      label="Measure On Time KPI on Collection?"
                      class="ui-grid-col-4"
                      id="onTimeCollection"
                      formControlName="measureOnTimeOnCollection"
                      binary="true"
                    ></p-checkbox>
                    <p-checkbox
                      label="Measure On Time KPI on Delivery?"
                      class="ui-grid-col-4"
                      id="onTimeDelivery"
                      formControlName="measureOnTimeOnDelivery"
                      binary="true"
                    ></p-checkbox>
                  </div>
                </div>
              </div>

              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2">Notifications</div>
                  <div class="ui-grid-col-10">
                    <p-checkbox
                      label="Pickup Notification"
                      class="ui-grid-col-4"
                      id="tpNotification"
                      formControlName="pickupNotification"
                      binary="true"
                    ></p-checkbox>
                    <p-checkbox
                      label="Dropoff Notification"
                      class="ui-grid-col-4"
                      id="tdNotification"
                      formControlName="dropoffNotification"
                      binary="true"
                    ></p-checkbox>
                  </div>
                </div>
              </div>
            </div>

            <div class="ui-g-12">
              <div class="ui-grid-row">
                <div class="ui-grid-col-2">Vehicle LifeCycle</div>
                <div class="ui-grid-col-2">
                  <input
                    type="button"
                    pButton
                    value="Configure Providers"
                    (click)="configureLifeCycleTeamProviders(team.id)"
                    class="vlc-provider-config-btn"
                  />
                </div>
              </div>
            </div>

            <div class="ui-g btn-to-right">
              <div>
                <span class="md-inputfield">
                  <button
                    type="submit"
                    pButton
                    [disabled]="currTeamForm.invalid"
                    label="Save"
                  ></button>
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div style="padding-top: 10px" *ngIf="currentnodetype == 'Depot'">
      <div class="card card-w-title" style="margin-bottom: 0px">
        <form
          [formGroup]="currDepotForm"
          (ngSubmit)="saveDepot(currDepotForm.value)"
          autocomplete="off"
        >
          <div class="ui-grid ui-grid-responsive ui-fluid">
            <div class="ui-g">
              <h2 class="sub-header-bar">Depot</h2>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="dName">Name</label></div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      id="dName"
                      formControlName="name"
                      maxlength="100"
                      [(ngModel)]="name"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="dAddressLine1">Address Line 1</label></div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      id="dAddressLine1"
                      formControlName="addressLine1"
                      maxlength="255"
                      [(ngModel)]="addressLine1"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="dAddressLine2">Address Line 2</label></div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      id="dAddressLine2"
                      formControlName="addressLine2"
                      maxlength="255"
                      [(ngModel)]="addressLine2"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="dAddressLine3">Address Line 3</label></div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      id="dAddressLine3"
                      formControlName="addressLine3"
                      maxlength="255"
                      [(ngModel)]="addressLine3"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="dTown">Town</label></div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      id="dTown"
                      formControlName="town"
                      maxlength="35"
                      [(ngModel)]="town"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="dPostcode">Post Code</label></div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      id="dPostcode"
                      formControlName="postCode"
                      maxlength="8"
                      [(ngModel)]="postCode"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="dEmail">Email Address</label></div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      id="dEmail"
                      formControlName="eMailAddress"
                      maxlength="254"
                      [(ngModel)]="email"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="dPhoneNumber">Phone Number</label></div>
                  <div class="ui-grid-col-10">
                    <input
                      pInputText
                      type="tel"
                      id="dPhoneNumber"
                      formControlName="phoneNumber"
                      maxlength="20"
                      [(ngModel)]="phoneNumber"
                    />
                  </div>
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-grid-row">
                  <div class="ui-grid-col-2"><label for="dAccountCode">Account Code</label></div>
                  <div class="ui-grid-col-10">
                    <p-dropdown
                      id="dAccountCode"
                      [options]="accountCodes"
                      formControlName="accountCodeId"
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [(ngModel)]="accountCodeId"
                    ></p-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <div class="ui-g btn-to-right">
              <div>
                <button
                  type="submit"
                  pButton
                  [disabled]="currDepotForm.invalid"
                  label="Save"
                ></button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div
      class="card card-w-title"
      style="margin-bottom: 0px; height: 100%"
      *ngIf="currentnodetype == 'Organisation'"
    >
      <div class="ui-grid ui-grid-responsive ui-fluid">
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oName">Name</label></div>
          <div class="ui-grid-col-10">
            <input pInputText disabled id="oName" [(ngModel)]="organisation.name" maxlength="100" />
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="otName">Organisation Type</label></div>
          <div class="ui-grid-col-10">
            <input
              pInputText
              disabled
              id="otName"
              [(ngModel)]="organisation.organisationTypeName"
            />
          </div>
        </div>

        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oAddressLine1">Address Line 1</label></div>
          <div class="ui-grid-col-10">
            <input
              pInputText
              disabled
              id="oAddressLine1"
              [(ngModel)]="organisation.addressLine1"
              maxlength="255"
            />
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oAddressLine2">Address Line 2</label></div>
          <div class="ui-grid-col-10">
            <input
              pInputText
              disabled
              id="oAddressLine2"
              [(ngModel)]="organisation.addressLine2"
              maxlength="255"
            />
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oTown">Town</label></div>
          <div class="ui-grid-col-10">
            <input pInputText disabled id="oTown" [(ngModel)]="organisation.town" maxlength="35" />
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oCity">City</label></div>
          <div class="ui-grid-col-10">
            <input pInputText disabled id="oCity" [(ngModel)]="organisation.city" />
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oCountry">Country</label></div>
          <div class="ui-grid-col-10">
            <input pInputText disabled id="oCountry" [(ngModel)]="organisation.country" />
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oPostcode">Post Code</label></div>
          <div class="ui-grid-col-10">
            <input
              pInputText
              disabled
              id="oPostcode"
              [(ngModel)]="organisation.postcode"
              maxlength="8"
            />
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oEmail">Email Address</label></div>
          <div class="ui-grid-col-10">
            <input
              pInputText
              disabled
              id="oEmail"
              [(ngModel)]="organisation.emailAddress"
              maxlength="254"
            />
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oAccountCode">Account Code</label></div>
          <div class="ui-grid-col-10">
            <input pInputText disabled id="oAccountCode" [(ngModel)]="organisation.accountCode" />
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-grid-col-2"><label for="oPhoneNumber">Phone Number</label></div>
          <div class="ui-grid-col-10">
            <input
              type="tel"
              pInputText
              disabled
              id="oPhoneNumber"
              [(ngModel)]="organisation.phoneNumber"
              maxlength="20"
            />
          </div>
        </div>
      </div>
    </div>
    <!--CREATE NEW FORMS-->
    <div
      style="padding-top: 10px"
      *ngIf="currentnodetype == 'Department' || currentnodetype == 'Region'"
    >
      <div class="card card-w-title" style="margin-bottom: 0px">
        <!--NEW TEAM-->
        <div
          *ngIf="currentnodetype == 'Department' && orgnodes.length > 0 && org_type == 'customer'"
        >
          <form
            [formGroup]="newTeamForm"
            (ngSubmit)="saveNewTeam(newTeamForm.value)"
            autocomplete="off"
          >
            <div class="ui-grid ui-grid-responsive ui-fluid">
              <h2 class="sub-header-bar">Team</h2>
              <div class="ui-g">
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2"><label for="new_tName">Name</label></div>
                    <div class="ui-grid-col-10">
                      <input pInputText id="new_tName" formControlName="name" maxlength="100" />
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2"><label for="dAccountCode">Cost Code</label></div>
                    <p-dropdown
                      class="ui-grid-col-10"
                      id="dAccountCode"
                      [options]="costCodes"
                      formControlName="accountCodeId"
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                    ></p-dropdown>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2">
                      <label for="new_teamPrimaryContactEmail">Primary Contact Email</label>
                    </div>
                    <div class="ui-grid-col-10">
                      <input
                        pInputText
                        id="new_teamPrimaryContactEmail"
                        formControlName="primaryContactEmail"
                        maxlength="254"
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2">
                      <label for="new_teamSecondaryContactEmail">Secondary Contact Email</label>
                    </div>
                    <div class="ui-grid-col-10">
                      <input
                        pInputText
                        id="new_teamSecondaryContactEmail"
                        formControlName="secondaryContactEmail"
                        maxlength="254"
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-g-12" *ngIf="isUserImpersonating">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2">KPIs</div>
                    <div class="ui-grid-col-10">
                      <p-checkbox
                        label="Measure On Time KPI on Collection?"
                        class="ui-grid-col-4"
                        id="onTimeCollection"
                        formControlName="measureOnTimeOnCollection"
                        binary="true"
                      ></p-checkbox>
                      <p-checkbox
                        label="Measure On Time KPI on Delivery?"
                        class="ui-grid-col-4"
                        id="onTimeDelivery"
                        formControlName="measureOnTimeOnDelivery"
                        binary="true"
                      ></p-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ui-g"></div>
              <div class="ui-g btn-to-right">
                <div>
                  <span class="md-inputfield">
                    <button
                      type="submit"
                      pButton
                      [disabled]="newTeamForm.invalid"
                      label="Add Team"
                    ></button>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>

        <!--NEW DEPOT-->
        <div *ngIf="currentnodetype == 'Region' && orgnodes.length > 0 && org_type == 'supplier'">
          <form
            [formGroup]="newDepotForm"
            (ngSubmit)="saveNewDepot(newDepotForm.value)"
            autocomplete="off"
          >
            <div class="ui-grid ui-grid-responsive ui-fluid">
              <h2 class="sub-header-bar">Depot</h2>
              <div class="ui-g">
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2"><label for="new_dName">Name</label></div>
                    <div class="ui-grid-col-10">
                      <input
                        pInputText
                        id="new_dName"
                        formControlName="name"
                        maxlength="100"
                        [(ngModel)]="name"
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2">
                      <label for="new_dAddressLine1">Address Line 1</label>
                    </div>
                    <div class="ui-grid-col-10">
                      <input
                        pInputText
                        id="new_dAddressLine1"
                        formControlName="addressLine1"
                        maxlength="255"
                        [(ngModel)]="addressLine1"
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2">
                      <label for="new_dAddressLine2">Address Line 2</label>
                    </div>
                    <div class="ui-grid-col-10">
                      <input
                        pInputText
                        id="new_dAddressLine2"
                        formControlName="addressLine2"
                        maxlength="255"
                        [(ngModel)]="addressLine2"
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2">
                      <label for="new_dAddressLine3">Address Line 3</label>
                    </div>
                    <div class="ui-grid-col-10">
                      <input
                        pInputText
                        id="new_dAddressLine3"
                        formControlName="addressLine3"
                        maxlength="255"
                        [(ngModel)]="addressLine3"
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2"><label for="new_dTown">Town</label></div>
                    <div class="ui-grid-col-10">
                      <input
                        pInputText
                        id="new_dTown"
                        formControlName="town"
                        maxlength="35"
                        [(ngModel)]="town"
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2"><label for="new_dPostcode">Post Code</label></div>
                    <div class="ui-grid-col-10">
                      <input
                        pInputText
                        id="new_dPostcode"
                        formControlName="postCode"
                        maxlength="8"
                        [(ngModel)]="postCode"
                      />
                    </div>
                  </div>
                </div>

                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2"><label for="new_dEmail">Email Address</label></div>
                    <div class="ui-grid-col-10">
                      <input
                        pInputText
                        id="new_dEmail"
                        formControlName="eMailAddress"
                        maxlength="254"
                        [(ngModel)]="email"
                      />
                    </div>
                  </div>
                </div>
                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2">
                      <label for="new_dPhoneNumber">Phone Number</label>
                    </div>
                    <div class="ui-grid-col-10">
                      <input
                        type="tel"
                        pInputText
                        id="new_dPhoneNumber"
                        formControlName="phoneNumber"
                        maxlength="20"
                        [(ngModel)]="phoneNumber"
                      />
                    </div>
                  </div>
                </div>

                <div class="ui-g-12">
                  <div class="ui-grid-row">
                    <div class="ui-grid-col-2">
                      <label for="new_dAccountCode">Account Code</label>
                    </div>
                    <div class="ui-grid-col-10">
                      <p-dropdown
                        id="new_dAccountCode"
                        [options]="accountCodes"
                        formControlName="accountCodeId"
                        autoWidth="false"
                        [style]="{ width: '100%' }"
                        [(ngModel)]="accountCodeId"
                      ></p-dropdown>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ui-g btn-to-right">
                <div>
                  <span class="md-inputfield">
                    <button
                      type="submit"
                      pButton
                      [disabled]="newDepotForm.invalid"
                      label="Add Depot"
                    ></button>
                  </span>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<p-dialog
  header="Region Details"
  [(visible)]="regionDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <form
    [formGroup]="newRegionForm"
    (ngSubmit)="saveNewRegion(newRegionForm.value)"
    autocomplete="off"
  >
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="rName">Name</label></div>
        <div class="ui-g-8">
          <input pInputText id="rName" formControlName="name" maxlength="100" />
        </div>
      </div>
    </div>
    <div style="float: right">
      <button
        type="submit"
        class="green-btn"
        icon="fa ui-icon-check"
        pButton
        [disabled]="newRegionForm.invalid"
        style="width: auto"
        label="Save"
      ></button>
      <button
        type="button"
        icon="fa ui-icon-close"
        pButton
        style="width: auto"
        (click)="cancelNewRegion()"
        label="Cancel"
      ></button>
    </div>
  </form>
</p-dialog>

<p-dialog
  header="Department Details"
  [(visible)]="dptDlg"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <form
    [formGroup]="newDepartmentForm"
    (ngSubmit)="saveNewDepartment(newDepartmentForm.value)"
    autocomplete="off"
  >
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="departamentName">Name</label></div>
        <div class="ui-g-8">
          <input
            name="name"
            pInputText
            id="departamentName"
            formControlName="name"
            maxlength="100"
          />
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="newAccountCode">Account Code</label></div>
        <div class="ui-g-8">
          <p-dropdown
            name="accountCodeId"
            id="newAccountCode"
            [options]="accountCodes"
            appendTo="body"
            formControlName="accountCodeId"
            [autoWidth]="false"
          ></p-dropdown>
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4">
          <label for="newInvoiceAddress"
            >Invoice Address
            <i
              class="pi pi-info-circle"
              style="vertical-align: top"
              pTooltip="{{ dptLevelInvoiceInfo }}"
            ></i
          ></label>
        </div>
        <div class="ui-g-8">
          <p-dropdown
            name="invoiceAddressId"
            id="invoiceAddressId"
            [options]="customerInvoiceAddressesSelect"
            appendTo="body"
            formControlName="invoiceAddressId"
            [autoWidth]="false"
            (onChange)="deptLevelInvoicingAddressChanged($event)"
          ></p-dropdown>
        </div>
      </div>
    </div>

    <div style="float: right">
      <button
        type="submit"
        class="green-btn"
        style="width: auto"
        pButton
        icon="fa ui-icon-check"
        [disabled]="newDepartmentForm.invalid"
        label="Save"
      ></button>
      <button
        type="button"
        pButton
        style="width: auto"
        (click)="cancelNewDepartment()"
        icon="fa ui-icon-close"
        label="Cancel"
      ></button>
    </div>
  </form>
</p-dialog>

<p-dialog
  [(visible)]="invAddrDlg"
  [responsive]="true"
  [modal]="true"
  class="invoice-address-dlg"
  *ngIf="selectedAddress"
>
  <p-header>
    {{ selectedAddress.invoiceCompanyName }}
    <small *ngIf="selectedAddress.isApproved" class="text-success">
      | <span>Approved <i class="pi pi-check"></i></span
    ></small>
    <small *ngIf="!selectedAddress.isApproved" class="text-warning"
      >| <span>Awaiting Approval <i class="pi pi-clock"></i></span
    ></small>
  </p-header>
  <ul class="ui-g-12 style-1">
    <li
      class="ui-g-12"
      *ngIf="selectedAddress.invoiceContactFirstName || selectedAddress.invoiceContactLastName"
    >
      <b>Contact 1</b>
      <p>
        {{ selectedAddress.invoiceContactFirstName }} {{ selectedAddress.invoiceContactLastName }}
      </p>
      <p>
        {{ selectedAddress.invoiceContactEmail }}
        <span *ngIf="selectedAddress.invoiceContactPhone"
          >| {{ selectedAddress.invoiceContactPhone }}</span
        >
      </p>
    </li>
    <li
      class="ui-g-12"
      *ngIf="selectedAddress.invoiceContact2FirstName || selectedAddress.invoiceContact2LastName"
    >
      <b>Contact 2</b>
      <p>
        {{ selectedAddress.invoiceContact2FirstName }} {{ selectedAddress.invoiceContact2LastName }}
      </p>
      <p>{{ selectedAddress.invoiceContact2Email }}</p>
    </li>
    <li
      class="ui-g-12"
      *ngIf="selectedAddress.invoiceContact3FirstName || selectedAddress.invoiceContact3LastName"
    >
      <b>Contact 3</b>
      <p>
        {{ selectedAddress.invoiceContact3FirstName }} {{ selectedAddress.invoiceContact3LastName }}
      </p>
      <p>{{ selectedAddress.invoiceContact3Email }}</p>
    </li>
    <li class="ui-g-12">
      <b>Address</b>
      <p>{{ selectedAddress.addressLine1 }}</p>
      <p>{{ selectedAddress.addressLine2 }}</p>
      <p>{{ selectedAddress.addressLine3 }}</p>
      <p>{{ selectedAddress.town }}</p>
      <p>{{ selectedAddress.postCode | postcode }}</p>
      <p>{{ selectedAddress.country }}</p>
      <p>{{ selectedAddress.purchaseOrderNumber }}</p>
    </li>
  </ul>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="invAddrDlg = false"
      label="Close"
      class="ui-button-secondary"
    ></button>
  </p-footer>
</p-dialog>

<p-dialog
  header="Manage Vehicle LifeCycle Team Configuration"
  [(visible)]="vehicleLifeCycleManageProvidersVisible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px', height: '350px' }"
>
  <div>
    <div class="col-12 mb-4">
      <strong>
        Please select a provider from the list below to configure the required team mappings. If a
        provider you expect to see is not in the list, please check if it has been enabled for the
        current customer account.
      </strong>
    </div>
    <div class="col-12 mb-4">
      <div class="ui-grid-col-4">
        <label><strong>Provider</strong></label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="vehicleLifeCycleProviderConnections"
          [optionLabel]="'providerName'"
          [dataKey]="'id'"
          [autoDisplayFirst]="false"
          styleClass="form-component"
          (onChange)="selectProviderConfiguration($event.value)"
          placeholder="Select Provider"
          [(ngModel)]="vehicleLifeCycleSelectedProvider"
        >
        </p-dropdown>
      </div>
    </div>
    <form [formGroup]="vehicleLifeCycleTeamProviderFormGroup">
      <div class="ui-g-12" style="margin-bottom: 50px">
        <div class="ui-grid-col-4">
          <label for="externalTeamId"><strong>External Team ID</strong></label>
        </div>
        <div class="ui-grid-col-8">
          <input
            pInputText
            class="form-component"
            formControlName="externalTeamId"
            id="externalTeamId"
          />
        </div>
      </div>
    </form>
  </div>
  <p-footer>
    <div class="button-box">
      <button
        class="btn-to-right"
        label="Save Changes"
        pButton
        type="button"
        [disabled]="
          !vehicleLifeCycleTeamProviderFormGroup.valid || vehicleLifeCycleProviderUpdateSaving
        "
        (click)="saveLifeCycleProviderConnection()"
      ></button>
      <button
        class="btn-to-right"
        label="Close"
        pButton
        type="button"
        (click)="vehicleLifeCycleManageProvidersVisible = false"
      ></button></div
  ></p-footer>
</p-dialog>

<ng-template #loading>Loading...</ng-template>
